/**
 * Created by pandemio on 10/16/18.
 */
import React from "react";
import SideNav, { Toggle, Nav, NavItem, NavIcon, NavText } from '@trendmicro/react-sidenav';

// Be sure to include styles at some point, probably during your bootstraping
import '@trendmicro/react-sidenav/dist/react-sidenav.css';

/** Multiple Language imports **/
import { withLocalize } from "react-localize-redux";
import { renderToStaticMarkup } from 'react-dom/server'; // Fix by the author. Do not remove even if it's not resolved
import { Translate } from "react-localize-redux";
import global from "../../translations/global.json"
import LanguageManager from '../../custom-classes/language-manager';
/** End of Multiple Language imports **/
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faUser, faIdCard, faDownload } from '@fortawesome/free-solid-svg-icons';
import { NavLink } from "react-router-dom";

class SidebarLanding extends React.Component {
    constructor(props) {
        super(props);

        this.props.initialize({
            languages: [
                { name: "English", code: "en" },
                { name: "Español", code: "es" }
            ],
            options: { renderToStaticMarkup, defaultLanguage: LanguageManager.getLanguage("en") }
        });

        this.state = {
            sidebarOpen: true
        };
        this.onSetSidebarOpen = this.onSetSidebarOpen.bind(this);

        this.props.addTranslation(global);
    }

    onSetSidebarOpen(open) {
        this.setState({ sidebarOpen: open });
    }

    render() {
        return (
            <SideNav className="sidebar-landing"
                onSelect={(selected) => {
                    // Add your code here
                }}
            >
                <SideNav.Toggle />
                <SideNav.Nav defaultSelected="home">
                    <NavItem eventKey="home">
                        <NavIcon>
                            <NavLink to="/" className="navbar-button">
                                <FontAwesomeIcon icon={faHome} style={{ fontSize: '1.75em' }} />
                            </NavLink>
                        </NavIcon>
                        <NavText>
                            <NavLink to="/" className="navbar-button">
                                <Translate id="navbar-landing.home" options={{renderInnerHtml: true}}/>
                            </NavLink>
                        </NavText>
                    </NavItem>
                    <NavItem eventKey="account">
                        <NavIcon>
                            <NavLink to="/login" className="navbar-button">
                                <FontAwesomeIcon icon={faUser} style={{ fontSize: '1.75em' }} />
                            </NavLink>
                        </NavIcon>
                        <NavText>
                            <NavLink to="/login" className="navbar-button">
                            <Translate id="navbar-landing.my-account" options={{renderInnerHtml: true}}/>
                            </NavLink>
                        </NavText>
                    </NavItem>
                    <NavItem eventKey="subscribe">
                        <NavIcon>
                            <NavLink to="/subscription-steps" className="navbar-button">
                                <FontAwesomeIcon icon={faIdCard} style={{ fontSize: '1.75em' }} />
                            </NavLink>
                        </NavIcon>
                        <NavText>
                            <NavLink to="/subscription-steps" className="navbar-button">
                                <Translate id="navbar-landing.subscribe" options={{renderInnerHtml: true}}/>
                            </NavLink>
                        </NavText>
                    </NavItem>
                    <NavItem eventKey="download">
                        <NavIcon>
                            <NavLink to="/download" className="navbar-button">
                                <FontAwesomeIcon icon={faDownload} style={{ fontSize: '1.75em' }} />
                            </NavLink>
                        </NavIcon>
                        <NavText>
                            <NavLink to="/download" className="navbar-button">
                                <Translate id="navbar-landing.download" options={{renderInnerHtml: true}}/>
                            </NavLink>
                        </NavText>
                    </NavItem>
                </SideNav.Nav>
            </SideNav>
        );
    }
}

export default withLocalize(SidebarLanding);


// WEBPACK FOOTER //
// ./src/components/navbar/sidebar-landing.js